export default class Animation {
    static moveRight(sprite, speed) {
        sprite.xModifier += speed;
    }

    static moveLeft(sprite, speed) {
        sprite.xModifier -= speed;
    }

    static moveUp(sprite, speed) {
        sprite.yModifier -= speed;
    }

    static moveDown(sprite, speed) {
        sprite.yModifier += speed;
    }

    static wait() {
        console.log('Animation delay...');
        return;
    }

    static hide(sprite) {
        sprite.visible = false;
    }

    static show(sprite) {
        sprite.visible = true;
    }

    static rotate(sprite, speed) {
        sprite.rotate(speed);
    }

    static resetRotation(sprite) {
        sprite.resetRotation();
    }

    static setOriginBottomLeft(sprite) {
        sprite.origin = { x: 0, y: 1 };
    }

    static setOriginCenter(sprite) {
        sprite.origin = { x: 0.5, y: 0.5 };
    }

    static resetOriginAndRotation(sprite) {
        sprite.origin = { x: 0.5, y: 0.5 };
        sprite.rotation = 0;
    }

}
